var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconQuestionbankCfa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_questionbank_cfa_selected") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9996\\u9875",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CFA\\u9898\\u5E93",
    transform: "translate(-230, -161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_questionbank_cfa_selected",
    transform: "translate(230, 161)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#FFFFFF",
    cx: 17,
    cy: 17,
    r: 17
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4931588,8 C20.6784052,8 21.651745,9.9158566 21.6970999,11.1404108 L21.6986282,11.2276506 L21.6986282,11.3030119 C23.0725807,11.773824 24,13.1019866 24,14.5985333 L24,22.5299803 C24,24.446412 22.497401,26 20.6438447,26 L13.3561553,26 C11.502599,26 10,24.446412 10,22.5299803 L10,10.1811451 C10.0517604,8.99510293 10.9736646,8.04778407 12.1210917,8.0015801 L12.2054694,8 L19.4931588,8 Z M20.6438447,12.5165252 L11.3424549,12.5165252 L11.3424549,22.5299803 C11.3424549,23.6800481 12.2438375,24.6119884 13.3561553,24.6119884 L20.6438447,24.6119884 C21.7561625,24.6119884 22.6575451,23.6800481 22.6575451,22.5299803 L22.6575451,14.5985333 C22.6575451,13.4484655 21.7561625,12.5165252 20.6438447,12.5165252 Z M19.4931588,9.23377673 L12.2054694,9.23377673 C11.7659566,9.2338179 11.3966625,10.0496806 11.3478308,11.1285136 L20.3507974,11.1285136 C20.3045039,10.104646 19.9683564,9.30908763 19.5522214,9.23852833 L19.4931588,9.23377673 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    stroke: "#14161E",
    strokeWidth: 0.5,
    fill: "#14161E",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuestionbankCfa);
export default __webpack_public_path__ + "static/media/icon_questionbank_cfa.svg";
export { ForwardRef as ReactComponent };